export { default } from './Alert';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/Alert/index.js
// module id = 880
// module chunks = 2